import React from "react"
import { 
  Modal,
  Button,
  Col,
  Row,
  FormControl,
} from "react-bootstrap"
import store from "store"
import FontAwesome from "react-fontawesome"
import { blockingFetchService } from "../../lib/blockingFetch"
import authServerApi from "../../redux/sagas/authServerApi"
import ProcessesStatus from "../fragments/ProcessesStatus"
import apiServerApi from "../../redux/sagas/apiServerApi"

class ImpersonationModalForm extends React.Component {

  constructor(props) {
    super(props)

    this.inputRef = null 
    this.setInputRef = elt => {
      this.inputRef = elt
    }
  }

  state = {
    password: '',
    passwordOk: false,
    showPassword: false,
    running: false,
    error: null,
  }

  validatePassword = () => {

    const { password } = this.state
    if(!password) {
      this.setState({ error: 'Please enter password!' })
      return
    }

    this.setState({
      running: true,
      passwordOk: false,
      error: null,
    })

    blockingFetchService(
      accessToken => authServerApi.validatePassword(accessToken, password),
      resp => this.setState({ passwordOk: resp }),
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  impersonateAction = () => {

    this.setState({
      running: true,
      error: null,
    })

    const { organization } = this.props

    blockingFetchService(
      accessToken => authServerApi.impersonation(accessToken, organization.id),
      user => {
        store.set('userInfo', user)
        this.loadOrganizationDetail(organization.id)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  loadOrganizationDetail = organizationId => {

    blockingFetchService(
      accessToken => apiServerApi.getOrganizationById(accessToken, organizationId),
      organization => {
        store.set('organization', organization)
        window.location.href = '/home'
      },
      error => this.setState({ error: error.text }),
      _ => {}
    )
  }

  passwordChanged = password => this.setState({ password, error: null })

  proceedClicked = () => {
    const { passwordOk } = this.state
    if(passwordOk) {
      this.impersonateAction()
    }
    else {
      this.validatePassword()
    }
  }

  handleKeyDown = event => {
    if(event.key === 'Enter') {
      this.proceedClicked()
    }
  }

  close = () => {

    this.setState({
      password: '',
      passwordOk: false,
      showPassword: false,
      running: false,
      error: null,
    })

    this.props.close()
  }

  toggleShowPassword = () => {
    if (this.inputRef.focus) {
      this.inputRef.focus()
    }
    this.setState({ showPassword: !this.state.showPassword })
  }

  renderPasswordConfirmation = () => {

    const { password, showPassword } = this.state

    return (
      <div>
        <strong className="mb-10 block">Confirm your password</strong>
        <div className="relative">

          <FormControl
            inputRef={ this.setInputRef }
            id="password"
            type={ showPassword ? 'text' : 'password' }
            placeholder="Password"
            value={ password }
            onChange={e => this.passwordChanged(e.target.value)}
            autoFocus
            maxLength={40}
            className="h-12 pr-16"
            onKeyDown={e => this.handleKeyDown(e)}
          />

          <div className="show-password right-2" onClick={ this.toggleShowPassword }>
            { showPassword ? 'Hide' : 'Show' }{' '}
            <FontAwesome name={ showPassword ? 'eye-slash' : 'eye' } />
          </div>
        </div>
      </div>
    )
  }

  renderImpersonationMessage = organization => (
    <div>
      <h3 className="blue">Act like an admin for &#171; { organization.name } &#187; Organization</h3>
      <p>Click "Proceed" to confirm!</p>
    </div>
  )

  render() {
    const { organization, show } = this.props,
    { passwordOk, error, running } = this.state

    return (
      <Modal show={ show } onHide={ this.close } >

        <Modal.Header closeButton>
          <Modal.Title>Impersonation</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col sm={4} className="mt-20 gray">
              <FontAwesome name="user-times" size="4x" />
                &nbsp; &nbsp; &nbsp; &nbsp;
              <FontAwesome name="user-md" size="5x" />
            </Col>

            <Col sm={8}>
              { passwordOk
              ? this.renderImpersonationMessage(organization)
              : this.renderPasswordConfirmation()
              }
              <ProcessesStatus
                error={ error }
                running={ running }
                success={ null }
              />
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={ this.close }>Cancel</Button>
          <Button onClick={ this.proceedClicked } bsStyle="primary" disabled={ running }>
            Proceed
          </Button>
        </Modal.Footer>

      </Modal>
    )
  }
}

export default ImpersonationModalForm



// WEBPACK FOOTER //
// ./src/components/Organizations/ImpersonationModalForm.js